module.exports = __webpack_public_path__ + "img/qwen-format-music-room.3b1e4c07.webp";